<template>
  <div class="delete-box" v-if="isShow">
    <div class="delete-wrap">
      <img
         class="close-icon"
         src="@/assets/html5/icon_close@2x.png"
         @click="isShowFn"
      >
      <div class="content-warp">
        <img class="error-icon" src="@/assets/html5/icon_result_declined@2x.png" alt="">
        <p class="content">
          <slot name="content"></slot>
        </p>
      </div>

      <el-button type="primary" @click="$emit('on-delete')">{{$t('APP-FIELD-0196')}}</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeleteBox",

    props: {
      isShow: {
        type: Boolean,
        default: false
      }

    },

    model: {
      prop: 'isShow',
      event: 'change'
    },

    methods: {
      isShowFn() {
        this.$emit('change', !this.isShow);
      },

      onDelete() {
        this.$emit('on-delete');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .delete-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.30);
    z-index: 1000;

    .delete-wrap {
      position: absolute;
      width: 673px;
      height: 406px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      /*padding: 34px 0px 0px;*/
      background: #FFFFFF;
      border-radius: 14px;
      padding: 72px 0 62px;
      text-align: center;
      .close-icon {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 44px;
        cursor: pointer;
      }

      .error-icon {
        width: 77px;
        height: 77px;
      }

      .content {
        text-align: center;
        line-height: 18px;
        margin: 38px 0 80px;
        font-size: 24px;
        color: #2C405A;
        letter-spacing: 0;
      }

      .btn-wrap {
        border-top: 1px solid #EAEEF3;
        padding: 10px 0;
        margin-top: 5px;

        span {
          font-family: SFProText-Semibold;
          font-size: 17px;
          color: #FF3801;
          letter-spacing: -0.41px;
          text-align: center;
          line-height: 22px;

        }
      }

    }
  }
</style>